import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN || '';

let initialized = false;

export function initAnalytics() {
  if (!MIXPANEL_TOKEN || initialized) return;

  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: true,
    persistence: 'localStorage',
  });

  initialized = true;
  track('App Opened');
}

function track(event, properties = {}) {
  if (!initialized) return;
  mixpanel.track(event, properties);
}

// ── Game Events ──

export function trackGameStarted({ difficulty, playerCount, isDaily }) {
  track('Game Started', { difficulty, player_count: playerCount, is_daily: isDaily || false });
}

export function trackHandPlayed({ cardValue, cardEffect, sum, isHuman }) {
  track('Hand Played', { card: cardValue, effect: cardEffect, new_sum: sum, is_human: isHuman });
}

export function trackRoundCompleted({ playerIndex, sum, roundNumber }) {
  track('Round Completed', { player_index: playerIndex, final_sum: sum, round: roundNumber });
}

export function trackRoundBusted({ playerName, sum }) {
  track('Round Busted', { player: playerName, bust_sum: sum });
}

export function trackGameOver({ winnerName, isHumanWinner, rounds, playerCount }) {
  track('Game Over', { winner: winnerName, human_won: isHumanWinner, rounds, player_count: playerCount });
}

export function trackThemeToggled(theme) {
  track('Theme Changed', { theme });
}

export function trackLanguageChanged(lang) {
  track('Language Changed', { language: lang });
}

export function trackDailyChallengeStarted({ playerCount, difficulty }) {
  track('Daily Challenge Started', { player_count: playerCount, difficulty });
}

export function trackDailyChallengeCompleted({ score, won }) {
  track('Daily Challenge Completed', { score, won });
}

export function trackDifficultyChanged(difficulty) {
  track('Difficulty Changed', { difficulty });
}

export function trackPlayerCountChanged(count) {
  track('Player Count Changed', { player_count: count });
}

// ── User Events ──

export function trackSignedIn(method) {
  track('Logged In', { method });
}

export function trackSignedUp(method) {
  track('Signed Up', { method });
}

export function trackPurchaseStarted(item) {
  track('Purchase Started', { item });
}

export function trackPurchaseCompleted(item) {
  track('Purchase Completed', { item });
}

export function trackProUpsellShown(trigger) {
  track('Pro Upsell Shown', { trigger });
}

// ── Identify user (call after auth) ──

export function identifyUser(userId, properties = {}) {
  if (!initialized) return;
  mixpanel.identify(userId);
  mixpanel.people.set(properties);
}
